<template>
  <div class="flex flex-col min-h-full">
    <topbar :title="$t('surveys.page-title')" />
    <div class="flex flex-col flex-1 p-3 xl:pt-8">
      <div class="flex-1 max-w-xl xl:max-w-6xl w-full mx-auto">
        <div class="title text-brand-1 xl:font-bold xl:text-5xl">Istruzioni</div>
        <div class="xl:text-4xl">
          <p>
            Rispondi alle domande senza pensarci troppo, indicando quali sono le parole che conosci e che usi abitualmente e spontaneamente.
          </p>
          <p>
            Ricorda che non ci sono risposte giuste o sbagliate e che è possibile indicare più di una risposta.
          </p>
          <p>
            Se fra quelle suggerite non trovi un’espressione che tu conosci o usi, puoi aggiungerla come risposta.
          </p>
        </div>
      </div>
      <div class="flex flex-col xl:flex-1 max-w-md w-full mx-auto ">
        <button class="btn btn-1" @click="setSurveyInfoRead()">{{$t('begin')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('surveys', ['answers'])
  },
  methods: {
    ...mapActions('surveys', ['setSurveyInfoRead'])
  }
}
</script>

<style scoped>
p {
  @apply mb-4;
}
</style>